import React from "react";
import { Outlet } from "react-router-dom";
import { Sidebar, MobileTopBar } from "@/components/layout/Sidebar";

export const AppLayout = () => {
    return (
        <div className="flex min-h-screen bg-surface-0">
            <Sidebar />
            <div className="flex min-w-0 flex-1 flex-col">
                <MobileTopBar />
                <main className="min-w-0 flex-1">
                    <Outlet />
                </main>
            </div>
        </div>
    );
};
